// extracted by mini-css-extract-plugin
export default {"hr":"AccountSignupForm--hr--UJLN0","hr-text":"AccountSignupForm--hr-text--rrMpt","hrText":"AccountSignupForm--hr-text--rrMpt"};